import { AuthenticatorEntry } from './Types'

class AuthenticatorUtils {
  generateId(): string {
    return `auth_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
  }

  validateAuthenticatorData(entry: Partial<AuthenticatorEntry>): boolean {
    if (
      !entry.name ||
      typeof entry.name !== 'string' ||
      entry.name.trim().length === 0
    ) {
      return false
    }

    if (
      entry.issuer !== undefined &&
      (typeof entry.issuer !== 'string' || entry.issuer.trim().length === 0)
    ) {
      return false
    }

    if (
      entry.account !== undefined &&
      (typeof entry.account !== 'string' || entry.account.trim().length === 0)
    ) {
      return false
    }

    if (!entry.isLocked) {
      if (
        !entry.secret ||
        typeof entry.secret !== 'string' ||
        entry.secret.trim().length === 0
      ) {
        return false
      }
    } else {
      if (!entry.encryptedSecret || typeof entry.encryptedSecret !== 'string') {
        return false
      }
      if (!entry.lockId || typeof entry.lockId !== 'string') {
        return false
      }
    }

    if (typeof entry.createdAt !== 'number' || entry.createdAt <= 0) {
      return false
    }

    if (
      entry.lockedAt !== undefined &&
      (typeof entry.lockedAt !== 'number' || entry.lockedAt <= 0)
    ) {
      return false
    }

    return true
  }

  sanitizeName(name: string): string {
    return name.trim().substring(0, 100)
  }

  sanitizeIssuer(issuer?: string): string | undefined {
    if (!issuer) return undefined
    const trimmed = issuer.trim()
    return trimmed.length > 0 ? trimmed.substring(0, 100) : undefined
  }

  sanitizeAccount(account?: string): string | undefined {
    if (!account) return undefined
    const trimmed = account.trim()
    return trimmed.length > 0 ? trimmed.substring(0, 100) : undefined
  }
}

export { AuthenticatorUtils }
